import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59990f98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between gap-2 border-b border-gray-200 px-4 py-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl" }, "🤖"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold text-gray-900" }, "Ассистент"),
    /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "учёт и терминалы")
  ])
], -1))
const _hoisted_3 = { class: "flex items-center gap-1" }
const _hoisted_4 = {
  key: 0,
  class: "max-h-56 overflow-y-auto border-b border-gray-200 bg-gray-50"
}
const _hoisted_5 = {
  key: 0,
  class: "px-4 py-3 text-sm text-gray-500"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "ml-1 text-xs text-gray-400" }
const _hoisted_8 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, " Задай вопрос по учёту своими словами — ассистент сам сходит в базу. ", -1))
const _hoisted_10 = { class: "mt-3 flex flex-wrap gap-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "flex justify-end"
}
const _hoisted_13 = { class: "max-w-[85%] whitespace-pre-wrap rounded-2xl rounded-br-md bg-blue-600 px-3.5 py-2 text-sm text-white" }
const _hoisted_14 = {
  key: 1,
  class: "my-1.5 flex items-center gap-1.5 text-xs text-gray-400"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "animate-pulse" }, "🔎", -1))
const _hoisted_16 = {
  key: 2,
  class: "my-2 rounded-xl border-2 border-amber-300 bg-amber-50 p-3.5"
}
const _hoisted_17 = { class: "flex items-start gap-2" }
const _hoisted_18 = { class: "text-lg leading-none" }
const _hoisted_19 = { class: "min-w-0 flex-1" }
const _hoisted_20 = { class: "text-xs font-semibold uppercase tracking-wide text-amber-700" }
const _hoisted_21 = { class: "mt-1 text-sm font-medium text-gray-900" }
const _hoisted_22 = {
  key: 0,
  class: "mt-1.5 rounded-lg bg-white/70 px-2.5 py-1.5 text-xs text-gray-600"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  class: "mt-1.5 text-xs text-gray-500"
}
const _hoisted_25 = {
  key: 2,
  class: "mt-3 flex gap-2"
}
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = ["disabled", "onClick"]
const _hoisted_28 = {
  key: 3,
  class: "mt-2 text-sm font-semibold text-green-700"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 4,
  class: "mt-2 text-sm font-semibold text-gray-500"
}
const _hoisted_31 = {
  key: 5,
  class: "mt-2 rounded-lg bg-red-50 px-2.5 py-1.5 text-xs text-red-700"
}
const _hoisted_32 = {
  key: 3,
  class: "flex justify-start"
}
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = {
  key: 1,
  class: "flex items-center gap-2 text-sm text-gray-400"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "animate-bounce" }, "●", -1))
const _hoisted_36 = {
  key: 2,
  class: "mt-2 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700"
}
const _hoisted_37 = { class: "border-t border-gray-200 p-3" }
const _hoisted_38 = { class: "flex items-end gap-2" }
const _hoisted_39 = ["disabled"]

import { nextTick, ref, watch } from "vue";
import {
  applyDraft,
  fetchDrafts,
  fetchThread,
  fetchThreads,
  rejectDraft,
  sendMessage,
  type AssistantEvent,
  type IAssistantDraft,
  type IAssistantThread,
} from "@/services/assistant.service";

type ChatItem = {
  kind: "user" | "assistant" | "tool" | "draft";
  text: string;
  draft?: IAssistantDraft;
  busy?: boolean;
  commandId?: number | null;
  draftError?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AssistantPanel',
  props: {
    open: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props;




const messages = ref<ChatItem[]>([]);
const threads = ref<IAssistantThread[]>([]);
const threadId = ref<number | null>(null);
const historyOpen = ref(false);
const draft = ref("");
const streaming = ref(false);
const hasStreamText = ref(false);
const errorText = ref("");
const scrollBox = ref<HTMLElement | null>(null);
const inputBox = ref<HTMLTextAreaElement | null>(null);
let cancelStream: (() => void) | null = null;

const suggestions = [
  "Балансы всех счетов",
  "ОПУ за прошлый месяц",
  "Что осталось неразнесённым?",
  "Аномалии в учёте",
  "Капитал учредителей",
];

const TOOL_LABELS: Record<string, string> = {
  get_balances: "смотрю балансы…",
  get_operations: "поднимаю операции…",
  get_pnl: "считаю ОПУ…",
  get_partner_capital: "смотрю капитал учредителей…",
  get_uncategorized: "ищу неразнесённое…",
  get_anomalies: "запускаю проверки…",
  run_sql_readonly: "выполняю SQL-запрос…",
  get_terminal_revenue: "считаю выручку терминалов…",
  get_terminal_status: "проверяю состояние терминалов…",
  get_services_prices: "смотрю услуги и цены…",
  get_shifts: "поднимаю смены сотрудников…",
  get_payroll: "считаю зарплату…",
  run_sql_readonly_terminals: "выполняю SQL к терминалам…",
};
const toolLabel = (name: string) => TOOL_LABELS[name] || `смотрю в БД (${name})…`;

const formatDate = (s: string) => {
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? "" : `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}`;
};

const fmtSum = (v?: number) => {
  if (v === undefined || v === null) return "—";
  return v.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ₽";
};

// --- минимальный markdown: экранирование + таблицы/жирный/код/списки ---
const escapeHtml = (s: string) =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

const inline = (s: string) =>
  escapeHtml(s)
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/`([^`]+)`/g, '<code class="rounded bg-gray-200 px-1 text-[13px]">$1</code>');

function renderMarkdown(src: string): string {
  const lines = src.split("\n");
  const out: string[] = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    // таблица: |a|b| со строкой-разделителем
    if (/^\s*\|.+\|\s*$/.test(line) && i + 1 < lines.length && /^\s*\|[\s\-:|]+\|\s*$/.test(lines[i + 1])) {
      const rows: string[][] = [];
      const parseRow = (l: string) => l.trim().replace(/^\||\|$/g, "").split("|").map((c) => c.trim());
      rows.push(parseRow(line));
      i += 2;
      while (i < lines.length && /^\s*\|.+\|\s*$/.test(lines[i])) {
        rows.push(parseRow(lines[i]));
        i++;
      }
      const [head, ...body] = rows;
      out.push('<div class="overflow-x-auto"><table class="my-1.5 w-full border-collapse text-[13px]">');
      out.push("<thead><tr>" + head.map((c) => `<th class="border-b border-gray-300 px-2 py-1 text-left font-semibold">${inline(c)}</th>`).join("") + "</tr></thead>");
      out.push("<tbody>" + body.map((r) => "<tr>" + r.map((c) => `<td class="border-b border-gray-200 px-2 py-1 align-top">${inline(c)}</td>`).join("") + "</tr>").join("") + "</tbody></table></div>");
      continue;
    }
    // блок кода ```
    if (/^\s*```/.test(line)) {
      const buf: string[] = [];
      i++;
      while (i < lines.length && !/^\s*```/.test(lines[i])) { buf.push(lines[i]); i++; }
      i++;
      out.push(`<pre class="my-1.5 overflow-x-auto rounded-lg bg-gray-800 p-2 text-xs text-gray-100">${escapeHtml(buf.join("\n"))}</pre>`);
      continue;
    }
    if (/^\s*#{1,4}\s+/.test(line)) {
      out.push(`<div class="mt-2 font-bold">${inline(line.replace(/^\s*#{1,4}\s+/, ""))}</div>`);
    } else if (/^\s*[-*]\s+/.test(line)) {
      out.push(`<div class="flex gap-1.5"><span>•</span><span>${inline(line.replace(/^\s*[-*]\s+/, ""))}</span></div>`);
    } else if (line.trim() === "") {
      out.push('<div class="h-2"></div>');
    } else {
      out.push(`<div>${inline(line)}</div>`);
    }
    i++;
  }
  return out.join("");
}

// --- поведение ---
const scrollDown = () => {
  void nextTick(() => {
    if (scrollBox.value) scrollBox.value.scrollTop = scrollBox.value.scrollHeight;
  });
};

const autoGrow = () => {
  const el = inputBox.value;
  if (!el) return;
  el.style.height = "auto";
  el.style.height = Math.min(el.scrollHeight, 128) + "px";
};

const loadThreads = async () => {
  try {
    threads.value = await fetchThreads();
  } catch {
    /* история недоступна — не мешаем чату */
  }
};

const toggleHistory = async () => {
  historyOpen.value = !historyOpen.value;
  if (historyOpen.value) await loadThreads();
};

const newThread = () => {
  threadId.value = null;
  messages.value = [];
  errorText.value = "";
  historyOpen.value = false;
};

const openThread = async (id: number) => {
  historyOpen.value = false;
  errorText.value = "";
  try {
    const data = await fetchThread(id);
    threadId.value = id;
    const items: ChatItem[] = [];
    for (const m of data.messages) {
      for (const block of m.content) {
        if (block.type === "text" && m.role === "user") items.push({ kind: "user", text: String(block.text || "") });
        else if (block.type === "text") items.push({ kind: "assistant", text: String(block.text || "") });
        else if (block.type === "tool_use") items.push({ kind: "tool", text: String(block.name || "") });
        // tool_result не показываем — это служебные данные
      }
    }
    // Восстановить непроведённые карточки-черновики этого треда
    try {
      const drafts = await fetchDrafts(id);
      for (const d of drafts) items.push({ kind: "draft", text: "", draft: d });
    } catch { /* черновики не критичны */ }
    messages.value = items;
    scrollDown();
  } catch {
    errorText.value = "Не удалось загрузить диалог";
  }
};

const send = (text?: string) => {
  const msg = (text ?? draft.value).trim();
  if (!msg || streaming.value) return;
  draft.value = "";
  autoGrow();
  errorText.value = "";
  messages.value.push({ kind: "user", text: msg });
  streaming.value = true;
  hasStreamText.value = false;
  scrollDown();

  let current: ChatItem | null = null;
  cancelStream = sendMessage(threadId.value, msg, (e: AssistantEvent) => {
    if (e.type === "thread") {
      threadId.value = e.thread_id;
    } else if (e.type === "text") {
      hasStreamText.value = true;
      if (!current) {
        current = { kind: "assistant", text: "" };
        messages.value.push(current);
      }
      current.text += e.delta;
      scrollDown();
    } else if (e.type === "tool") {
      messages.value.push({ kind: "tool", text: e.name });
      current = null; // после инструмента ответ пойдёт новым пузырём
      scrollDown();
    } else if (e.type === "draft") {
      messages.value.push({ kind: "draft", text: "", draft: e.draft });
      current = null;
      scrollDown();
    } else if (e.type === "error") {
      errorText.value = e.message;
      streaming.value = false;
      scrollDown();
    } else if (e.type === "done") {
      streaming.value = false;
      cancelStream = null;
    }
  });
};

const stop = () => {
  if (cancelStream) cancelStream();
  cancelStream = null;
  streaming.value = false;
};

// Подтверждение действия — сервер зовёт central-эндпоинт кабинета
const confirmDraft = async (item: ChatItem) => {
  if (!item.draft || item.busy) return;
  item.busy = true;
  item.draftError = "";
  try {
    const res = await applyDraft(item.draft.id);
    if (res.error) {
      item.draftError = res.error;
    } else if (res.applied || res.already) {
      item.draft.status = "applied";
      item.commandId = res.command_id ?? null;
    }
  } catch {
    item.draftError = "Не удалось выполнить действие";
  } finally {
    item.busy = false;
    scrollDown();
  }
};

const declineDraft = async (item: ChatItem) => {
  if (!item.draft || item.busy) return;
  item.busy = true;
  try {
    await rejectDraft(item.draft.id);
    item.draft.status = "rejected";
  } catch {
    item.draftError = "Не удалось отклонить";
  } finally {
    item.busy = false;
  }
};

watch(
  () => props.open,
  (v) => {
    if (v) void nextTick(() => inputBox.value?.focus());
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-40 bg-black/30 sm:bg-transparent",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("aside", {
      class: _normalizeClass(["fixed right-0 top-0 z-50 flex h-full w-full flex-col bg-white text-left shadow-2xl transition-transform duration-200 sm:w-[460px] sm:border-l sm:border-gray-200", _ctx.open ? 'translate-x-0' : 'translate-x-full'])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "rounded-md px-2 py-1.5 text-xs font-semibold text-gray-600 hover:bg-gray-100",
            title: "История диалогов",
            onClick: toggleHistory
          }, " ☰ История "),
          _createElementVNode("button", {
            type: "button",
            class: "rounded-md px-2 py-1.5 text-xs font-semibold text-blue-600 hover:bg-blue-50",
            onClick: newThread
          }, " + Новый "),
          _createElementVNode("button", {
            type: "button",
            class: "rounded-md px-2 py-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600",
            title: "Закрыть",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, " ✕ ")
        ])
      ]),
      (historyOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (threads.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Прошлых диалогов нет "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(threads.value, (t) => {
              return (_openBlock(), _createElementBlock("button", {
                key: t.id,
                type: "button",
                class: _normalizeClass(["block w-full truncate px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100", t.id === threadId.value ? 'bg-blue-50 font-semibold text-blue-700' : '']),
                onClick: ($event: any) => (openThread(t.id))
              }, [
                _createTextVNode(_toDisplayString(t.title || "Без названия") + " ", 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(formatDate(t.created_at)), 1)
              ], 10, _hoisted_6))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref_key: "scrollBox",
        ref: scrollBox,
        class: "flex-1 overflow-y-auto px-4 py-3"
      }, [
        (messages.value.length === 0 && !streaming.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(suggestions, (s) => {
                  return _createElementVNode("button", {
                    key: s,
                    type: "button",
                    class: "rounded-full border border-blue-200 bg-blue-50 px-3 py-1.5 text-xs font-medium text-blue-700 hover:bg-blue-100",
                    onClick: ($event: any) => (send(s))
                  }, _toDisplayString(s), 9, _hoisted_11)
                }), 64))
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (m, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "mb-3"
          }, [
            (m.kind === 'user')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(m.text), 1)
                ]))
              : (m.kind === 'tool')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(toolLabel(m.text)), 1)
                  ]))
                : (m.kind === 'draft' && m.draft)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(m.draft.kind === "action" ? "⚙️" : "🏷️"), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(m.draft.kind === "action" ? "Действие — требует подтверждения" : "Разметка учёта — на одобрение"), 1),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(m.draft.title), 1),
                          (m.draft.preview)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createTextVNode(" Затронет операций: "),
                                _createElementVNode("b", null, _toDisplayString(m.draft.preview.uncategorized.count), 1),
                                _createTextVNode(" (безобъектных) на "),
                                _createElementVNode("b", null, _toDisplayString(fmtSum(m.draft.preview.uncategorized.sum)), 1),
                                (m.draft.preview.total.count !== m.draft.preview.uncategorized.count)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, " · всего под правило " + _toDisplayString(m.draft.preview.total.count), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : (m.draft.kind === 'categorize' && m.draft.count)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Операций: " + _toDisplayString(m.draft.count) + " · сумма " + _toDisplayString(fmtSum(m.draft.sum)), 1))
                              : _createCommentVNode("", true),
                          (m.draft.status === 'proposed')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "rounded-lg bg-green-600 px-3.5 py-2 text-sm font-bold text-white hover:bg-green-700 disabled:opacity-50",
                                  disabled: m.busy,
                                  onClick: ($event: any) => (confirmDraft(m))
                                }, _toDisplayString(m.busy ? "…" : (m.draft.kind === "action" ? "Подтвердить" : "Одобрить")), 9, _hoisted_26),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "rounded-lg border border-gray-300 bg-white px-3.5 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-100 disabled:opacity-50",
                                  disabled: m.busy,
                                  onClick: ($event: any) => (declineDraft(m))
                                }, "Отклонить", 8, _hoisted_27)
                              ]))
                            : (m.draft.status === 'applied')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  (m.draft.kind === 'action')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode("✅ Выполнено"),
                                        (m.commandId)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, " · команда №" + _toDisplayString(m.commandId), 1))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode("✅ Одобрено · в книги пока не записано (перенос в У4)")
                                      ], 64))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_30, "✕ Отклонено")),
                          (m.draftError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(m.draftError), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", {
                        class: "assistant-md max-w-[95%] rounded-2xl rounded-bl-md bg-gray-100 px-3.5 py-2 text-sm text-gray-900",
                        innerHTML: renderMarkdown(m.text)
                      }, null, 8, _hoisted_33)
                    ]))
          ]))
        }), 128)),
        (streaming.value && !hasStreamText.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              _createTextVNode(" думаю… ")
            ]))
          : _createCommentVNode("", true),
        (errorText.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(errorText.value), 1))
          : _createCommentVNode("", true)
      ], 512),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _withDirectives(_createElementVNode("textarea", {
            ref_key: "inputBox",
            ref: inputBox,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((draft).value = $event)),
            rows: "1",
            placeholder: "Вопрос по учёту или точкам…",
            class: "max-h-32 min-h-[42px] flex-1 resize-none rounded-xl border border-gray-300 px-3 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500",
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (send()), ["exact","prevent"]), ["enter"])),
            onInput: autoGrow
          }, null, 544), [
            [_vModelText, draft.value]
          ]),
          (streaming.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "rounded-xl bg-gray-200 px-4 py-2.5 text-sm font-semibold text-gray-700 hover:bg-gray-300",
                onClick: stop
              }, " Стоп "))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "rounded-xl bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-40",
                disabled: !draft.value.trim(),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (send()))
              }, " ➤ ", 8, _hoisted_39))
        ])
      ])
    ], 2)
  ], 64))
}
}

})